module.exports = __webpack_public_path__ + "img/ic_twitter.c5452437.svg";